import dayjs from 'dayjs';
import { IBridgeLoanGridRecord } from '@apply/api/src/api/loanApi';

// The Outstanding grid's groups, in display order.
export enum BridgeOutstandingGroup {
    OnBalanceSheet = 0,
    NearInitialMaturity = 1,
    Extension1 = 2,
    Extension2 = 3,
}

export const bridgeOutstandingGroupLabels: Record<BridgeOutstandingGroup, string> = {
    [BridgeOutstandingGroup.OnBalanceSheet]: 'ON BALANCE SHEET',
    [BridgeOutstandingGroup.NearInitialMaturity]: 'Within 2 weeks of Initial Maturity',
    [BridgeOutstandingGroup.Extension1]: 'Extension 1',
    [BridgeOutstandingGroup.Extension2]: 'Extension 2',
};

const nearMaturityDays = 14;

export const getBridgeOutstandingGroup = (
    loan: Pick<IBridgeLoanGridRecord, 'extensionCount' | 'maturityDate'>
): BridgeOutstandingGroup => {
    if (loan.extensionCount >= 2) {
        return BridgeOutstandingGroup.Extension2;
    }
    if (loan.extensionCount === 1) {
        return BridgeOutstandingGroup.Extension1;
    }
    if (loan.maturityDate && !dayjs(loan.maturityDate).isAfter(dayjs().startOf('day').add(nearMaturityDays, 'day'))) {
        return BridgeOutstandingGroup.NearInitialMaturity;
    }
    return BridgeOutstandingGroup.OnBalanceSheet;
};
